import {Button} from 'platform/components';
import {Box, Heading, Space, Text, VStack} from 'platform/foundation';

import {useGetMyOutlookCalendarsQuery} from '@dms/api/core';
import {useHandleSelectOAuthProvider} from '@dms/features/email-smtp';
import i18n from '@dms/i18n';

import {useBoolean} from 'shared/web';

import {MyProfileTemplate} from '../../components/MyProfileTemplate/MyProfileTemplate';
import {CalendarSyncSettings} from './components/CalendarSyncSettings';

export function CalendarSynchronization() {
  const {isSuccess: isAuthenticated, isLoading} = useGetMyOutlookCalendarsQuery();

  const [isOAuthLoading, startOAuthLoading, stopOAuthLoading] = useBoolean(false);
  const [startOAuth] = useHandleSelectOAuthProvider({purpose: 'calendar'});

  return (
    <MyProfileTemplate
      isLoading={isLoading}
      header={{
        title: i18n.t('page.myProfile.labels.calendarSynchronization'),
        breadcrumbs: [
          {label: i18n.t('entity.user.labels.myProfile'), isCurrentPage: true},
          {label: i18n.t('page.myProfile.labels.calendarSynchronization'), isCurrentPage: true},
        ],
      }}
    >
      <Box maxWidth={200}>
        <VStack spacing={6}>
          <Heading size={4}>{i18n.t('page.myProfile.labels.microsoftOutlookSync')}</Heading>
          <Text size="small" color="tertiary">
            {i18n.t('page.myProfile.messages.outlookSyncDescription')}
          </Text>
        </VStack>
        <Space vertical={6} />
        {isAuthenticated ? (
          <CalendarSyncSettings />
        ) : (
          <VStack spacing={6} align="flex-start">
            <Button
              variant="primary"
              title={i18n.t('page.myProfile.actions.connectOutlookCalendar')}
              isLoading={isOAuthLoading}
              onClick={() => startOAuth(startOAuthLoading, stopOAuthLoading)}
            />
          </VStack>
        )}
      </Box>
    </MyProfileTemplate>
  );
}
